import React from "react";

interface SchemaOrgDataProps {
  type: "Organization" | "LocalBusiness" | "Service" | "BreadcrumbList";
  data: any;
}

export default function SchemaOrgData({ type, data }: SchemaOrgDataProps) {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
    />
  );
}

// Organization schema for homepage
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Alkanes Engineering Limited",
  alternateName: "Alkanes Engineering",
  description:
    "Professional engineering services for Oil & Gas, Power, Infrastructure, and Construction sectors in Lagos, Nigeria",
  url: "https://alkanesengineering.com",
  image: "https://alkanesengineering.com/icon_256x256.png",
  telephone: "+2348025568836",
  email: "info@alkanesengineering.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Lagos",
    addressLocality: "Lagos",
    addressRegion: "Lagos",
    postalCode: "",
    addressCountry: "NG",
  },
  sameAs: [
    "https://www.facebook.com/alkanesengineering",
    "https://www.linkedin.com/company/alkane-engineering-limited",
  ],
  serviceArea: {
    "@type": "Place",
    name: "Nigeria",
  },
  areaServed: ["NG"],
  knowsAbout: [
    "Oil and Gas Engineering",
    "Construction Services",
    "Procurement",
    "Equipment Installation",
    "Equipment Leasing",
    "Safety Equipment",
    "Infrastructure",
  ],
};

// Breadcrumb schema helper
export function createBreadcrumbSchema(items: Array<{ name: string; url: string }>) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
